async function loadSwatches() {
  try {
    // Start from the current page URL
    const url = new URL(window.location.href);

    // Add or update the `view` parameter
    url.searchParams.set('view', 'oleka-swatches');

    // Fetch the JSON from the same page but with ?view=oleka-swatches
    const res = await fetch(url.toString());

    const items = await res.json();

    items.forEach(({ id, swatches }) => {
      const container = document.getElementById(`oleka-swatches-${id}`);
      if (container) {
        container.innerHTML = swatches;
      }
    });
  } catch (err) {
    console.error('Failed to load swatches:', err);
  }
}

// Call it after the function is defined
document.addEventListener('DOMContentLoaded', loadSwatches);


//reload swatches on collection reload (infinite scroll, filter...)
document.addEventListener('collection:reloaded', function (event) {
  loadSwatches(); 
});


/*  Load swatch variant URLs in collection pages (robust resolver). */

/* --- Apply espace_couvrir filter to all swatch links --- */

async function loadVariantsFromEspaceCouvrir() {
  try {
    // 1) Get the filter value from the current page URL
    const pageUrl = new URL(window.location.href);
    const espaceFilter = pageUrl.searchParams.get('filter.v.m.custom.espace_couvrir');
    if (!espaceFilter) {
      console.info('[variants] No espace_couvrir filter in URL; skipping rewrite.');
      return;
    }
    const norm = s => String(s).trim().toLowerCase();
    const wanted = norm(espaceFilter);

    // 2) Fetch the variants JSON from the same page (?view=oleka-swatches-variants)
    pageUrl.searchParams.set('view', 'oleka-swatches-variants');
    console.log('[variants] Fetching:', pageUrl.toString());

    const res = await fetch(pageUrl.toString());
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const products = await res.json();

    console.log('[variants] Product objects:', products.length);

    // 3) Build a quick index: productId (string) -> related_variants[]
    const byProductId = new Map();
    for (const prod of products) {
      for (const v of (prod.related_variants || [])) {
        const pid = String(v.id); // v.id == product id for that variant
        if (!byProductId.has(pid)) byProductId.set(pid, []);
        byProductId.get(pid).push(v);
      }
    }
    console.log('[variants] Indexed product ids:', byProductId.size);

    // 4) For every swatch on the page, update links if we find a matching variant
    document.querySelectorAll('[id^="oleka-swatches-"]').forEach(container => {
      container.querySelectorAll('color-swatch').forEach(colorEl => {
        const pid = colorEl.getAttribute('data-id');
        if (!pid) {
          // Keep it simple: skip swatches without a product id
          return;
        }

        const variants = byProductId.get(String(pid));
        if (!variants || variants.length === 0) {
          // No variants for that product id in JSON
          return;
        }

        // Find a variant whose espace_couvrir contains the wanted value
        const match = variants.find(v =>
          Array.isArray(v.espace_couvrir) &&
          v.espace_couvrir.some(ec => norm(ec) === wanted)
        );

        if (!match) {
          // No variant for this product matches the filter; leave as-is
          return;
        }

        // 5) Update URLs using the canonical JSON URL (correct handle + ?variant=vid)
        const links = colorEl.querySelectorAll('.swatch-link');
        links.forEach(link => link.setAttribute('href', match.url));
        if (colorEl.hasAttribute('data-url')) {
          colorEl.setAttribute('data-url', match.url);
        }
      });
    });

    console.log('[variants] Swatch links updated from espace_couvrir filter:', espaceFilter);
  } catch (err) {
    console.error('[variants] Error applying espace_couvrir filter:', err);
  }
}


// If you previously commented these out, re-enable so the rewrite actually runs:
document.addEventListener('DOMContentLoaded', async () => {
  try {
    await loadSwatches();
    await loadVariantsFromEspaceCouvrir();
  } catch (e) { console.error(e); }
});

document.addEventListener('collection:reloaded', async () => {
  try {
    await loadSwatches();
    await loadVariantsFromEspaceCouvrir();
  } catch (e) { console.error(e); }
});
